import React, {useState} from "react";

const FileSelect = (props: any) => {
    const [openModal, setOpenModal] = useState(false);
    return (
        <div>
            <button
                className="w-full inline-flex justify-center rounded-sm border border-transparent drop-shadow-lg px-4 py-2 bg-button-BG text-base font-medium text-white hover:bg-button-hover sm:ml-3 sm:w-auto sm:text-sm"
                onClick={() => setOpenModal(true)}>SELECT
            </button>
        </div>);
};


export default FileSelect;
